import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../shared/lib/query-keys.ts";
import { getTrendsDashboard } from "../api/trends-api.ts";
import type { TrendsDashboard } from "../types/index.ts";

export function useTrendsDashboardQuery(period: 7 | 30 | 90, enabled: boolean) {
  return useQuery<TrendsDashboard | null>({
    queryKey: queryKeys.trends.dashboard(period),
    queryFn: () => getTrendsDashboard(period),
    enabled,
  });
}
